import { useQuery } from '@tanstack/react-query';

import axios from '@/portainer/services/axios';
import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { withGlobalError } from '@/react-tools/react-query';

import { Registry } from '../types/registry';

import { buildUrl } from './build-url';

export function useRegistryPing(
  registryId: Registry['Id'],
  options?: { enabled?: boolean }
) {
  const environmentId = useEnvironmentId(false);

  return useQuery(
    ['environment', environmentId, 'registries', registryId, 'ping'],
    () => pingRegistry(registryId, environmentId),
    {
      ...options,
      ...withGlobalError(),
    }
  );
}

async function pingRegistry(registryId: Registry['Id'], environmentId: number) {
  // Docker Registry V2 API expects /v2/ with trailing slash
  const { data } = await axios.get(`${buildUrl(registryId)}/v2/`, {
    params: { endpointId: environmentId },
    headers: {
      Accept: 'application/json',
    },
  });
  return data;
}
